export default "__VITE_ASSET__D$PhaslV__"